










































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { IOffer } from "@/store/interfaces/offer";
import OfferCard from "@/components/offer/OfferCard.vue";
import api from "@/api/index.ts";
import { mapGetters } from "vuex";
import OfferPreload from "@/components/common/preloaders/OfferPreload.vue";
import ToggleButton from "@/components/pages/products/ToggleButton.vue";
import Filters from "@/components/pages/products/Filters.vue";

@Component({
  name: "ProductsContent",
  components: {
    Filters,
    ToggleButton,
    OfferCard,
    OfferPreload
  },
  computed: mapGetters("products", [
    "getProducts",
    "getCategories",
    "getStores",
    "getStoresCount",
    "getCount",
    "getCategory",
    "getCurrentCursor",
    "isLangChanging",
    "getHasPrev",
    "getHasNext",
    "getIsFiltering",
    "getWasFiltered",
    "getResetButtonDisable"
  ])
})
export default class ProductsContent extends Vue {
  getCategory: any;
  getCategories: any[];
  getStores: any[];
  getStoresCount: number;
  getCurrentCursor: string;
  isLangChanging: boolean;
  isLoading: boolean = true;
  showFilter: boolean = true;
  getWasFiltered: boolean;
  getResetButtonDisable: boolean;
  getHasPrev: boolean;
  getIsFiltering: boolean;

  toggleFilters() {
    this.showFilter = !this.showFilter;
  }

  checkCurrentLang() {
    return localStorage.getItem("currentLang");
  }

  pushRouter(path) {
    if (path !== this.$router.currentRoute.fullPath) {
      this.$router.push({ path });
    }
  }

  async beforeMount() {
    await this.$store.dispatch("products/getCategories");
    let categoryID;
    let cursor;
    if (!location.search) {
      categoryID = this.getCategories[0]["category_id"];
      this.pushRouter(
        `/${this.checkCurrentLang()}/products?category=${categoryID}`
      );
    } else {
      categoryID = decodeURIComponent(
        location.search.split("&cursor")[0].split("=")[1]
      );
      cursor = "";
      if (location.search.split("&cursor").length === 2) {
        cursor = location.search.split("&cursor")[1].split("=")[1];
      }
    }
    this.$store.dispatch("products/fetchFilterParams", [categoryID]);
    await this.$store.dispatch("products/fetchProducts", {
      category: categoryID,
      count: 20,
      direction: null,
      cursor
    });
    this.isLoading = false;
  }

  selectClass() {
    return {
      "select-category-disabled":
        this.isLoading || this.getIsFiltering || !this.getStores.length
    };
  }

  async nextPage() {
    this.isLoading = true;
    this.$store.dispatch("products/setIsFiltering", true);
    await this.$store.dispatch("products/fetchProducts", {
      category: this.getCategory,
      count: 20,
      direction: 1
    });
    this.isLoading = false;
  }

  async prevPage() {
    this.isLoading = true;
    this.$store.dispatch("products/setIsFiltering", true);
    await this.$store.dispatch("products/fetchProducts", {
      category: this.getCategory,
      count: 20,
      direction: -1
    });
    this.isLoading = false;
  }

  async onChangeCurrentCategory(item) {
    this.isLoading = true;
    await this.$store.dispatch("products/setCurrentCategory", item.category_id);
    await this.$store.dispatch("products/deletePrice");
    await this.$store.dispatch("products/removeStores");
    await this.$store.dispatch("products/setSort", [""]);
    this.$store.dispatch("products/fetchProducts", {
      category: item.category_id,
      count: 20,
      direction: null
    });
    this.isLoading = false;
    await this.$store.dispatch("products/fetchFilterParams", [
      item.category_id
    ]);
    await this.pushRouter(
      `/${this.checkCurrentLang()}/products?category=${item.category_id}`
    );
  }

  getCurrentCategoryName() {
    const currentCat = this.getCategories.filter(cat => {
      return this.getCategory === cat["category_id"];
    })[0];

    return currentCat ? currentCat.name : "";
  }

  @Watch("getCurrentCursor")
  async onGetCurrentCursorChanged(value) {
    let cursor = "";
    if (this.getWasFiltered || !this.getResetButtonDisable || this.getHasPrev) {
      cursor = this.getCurrentCursor ? "&cursor=" + this.getCurrentCursor : "";
    }
    this.pushRouter(
      `/${this.checkCurrentLang()}/products?category=${
        this.getCategory
      }${cursor}`
    );
  }

  @Watch("getProducts")
  async onGetProductsChange(value) {
    this.$forceUpdate(); // in order to not to show images of old products in new products
  }
}
